import * as React from 'react';
import {
    BackButton,
    BackButtonIconType,
    BodyLargeRegular,
    View,
    XStack,
} from 'smoothie';

interface BillEditHeaderProps {
    title: string;
}

const BillDetailsEditHeader = ({ title }: BillEditHeaderProps) => {
    return (
        <XStack width="100%" alignItems="center" justifyContent="space-between">
            <BackButton
                iconType={BackButtonIconType.ARROW_LEFT}
                style={{ paddingHorizontal: 0 }}
            />
            <BodyLargeRegular>{title}</BodyLargeRegular>
            <View width={16} height={34} />
        </XStack>
    );
};

export default BillDetailsEditHeader;
